"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _filterUtils = require("@nicbase/filter-utils");

var _request = require("@nicbase/request");

var _types = require("@nicbase/types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var findAdminGatewayProviders = function findAdminGatewayProviders(_ref) {
  var dynamicFilters = _ref.dynamicFilters,
      dynamicPaging = _ref.dynamicPaging,
      dynamicSorters = _ref.dynamicSorters;
  return {
    type: 'ADMIN_FIND_PROVIDERS_BY_FILTER_REQUEST',
    headers: {
      version: 'v1'
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicPaging: dynamicPaging,
      dynamicSorters: dynamicSorters
    }
  };
};

var attributeMapping = {
  id: 'provider.id',
  name: 'provider.name'
};

var useAdminGatewayProviders = function useAdminGatewayProviders() {
  var requestParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var queryOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _requestParams$filter = requestParams.filters,
      filters = _requestParams$filter === void 0 ? {} : _requestParams$filter,
      _requestParams$pageSi = requestParams.pageSize,
      pageSize = _requestParams$pageSi === void 0 ? null : _requestParams$pageSi,
      _requestParams$sortin = requestParams.sorting;
  _requestParams$sortin = _requestParams$sortin === void 0 ? {} : _requestParams$sortin;
  var _requestParams$sortin2 = _requestParams$sortin.sortBy,
      sortBy = _requestParams$sortin2 === void 0 ? 'id' : _requestParams$sortin2,
      _requestParams$sortin3 = _requestParams$sortin.sortDirection,
      sortDirection = _requestParams$sortin3 === void 0 ? 'ASC' : _requestParams$sortin3;
  var id = filters.id,
      name = filters.name;
  return (0, _reactQuery.useInfiniteQuery)(['admin', 'gatewayProviders', {
    id: id,
    name: name,
    sortBy: sortBy,
    sortDirection: sortDirection
  }], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$pageParam, pageNumber, pagination, _and, filterTree, _yield$request, providers;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$pageParam = _ref2.pageParam, pageNumber = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;
              pagination = null;

              if (pageSize) {
                pagination = {
                  pageNumber: pageNumber,
                  pageSize: pageSize
                };
              }

              _and = (0, _filterUtils.and)((0, _filterUtils.equal)('provider.id', id, _types.FilterAttributeType.Integer), (0, _filterUtils.like)('provider.name', name, _types.FilterAttributeType.String)), filterTree = _and.filterTree;
              _context.next = 6;
              return request(findAdminGatewayProviders({
                dynamicFilters: filterTree,
                dynamicPaging: pagination,
                dynamicSorters: [{
                  attributeName: attributeMapping[sortBy],
                  sortOrder: sortDirection
                }]
              }));

            case 6:
              _yield$request = _context.sent;
              providers = _yield$request.body.providers;
              return _context.abrupt("return", providers);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), _objectSpread({
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      if (pageSize === null || lastPage.length < pageSize) {
        return undefined;
      }

      return allPages.length;
    }
  }, queryOptions));
};

var _default = useAdminGatewayProviders;
exports["default"] = _default;